import { Injectable } from '@angular/core';
import { BehaviorSubject, debounceTime, fromEvent } from 'rxjs';

export interface ScrollStats {
    isScrolled: boolean;
    scrollTop: number;
}

@Injectable({
    providedIn: 'root',
})
export class ScreenScrollService {
    private scrollSubject = new BehaviorSubject<ScrollStats>({
        isScrolled: false,
        scrollTop: 0,
    }); // Observable for scroll events
    scrollSubject$ = this.scrollSubject.asObservable();

    constructor() {}
}
